<template>
  <div class="image-loader">
    <v-col :cols="cols">
      <v-hover v-slot:default="{ hover }">
        <v-card class="mx-auto" color="grey lighten-4">
          <v-img
            aspect-ratio="1"
            :height="height"
            :width="width"
            position="relative"
            :src="source"
          >
          <input
            ref="uploader"
            class="d-none"
            type="file"
            accept="image/*"
            @change="load"
          />
          <v-expand-transition>
            <v-btn tile
              v-if="hover"
              @click="select"
              class="image-loader__btn"
            >
              <v-icon>mdi-camera</v-icon>
            </v-btn>
          </v-expand-transition>
          </v-img>
        </v-card>
      </v-hover>

      <v-dialog v-model="dialog" :max-width="dialogWidth" style="max-height: 70vh; background-color: blue;">
        <v-card class="image-loader-dialog">
          <!-- Clipper -->
          <clipper-fixed
            :area="70"
            class=""
            ref="clipper"
            :ratio="nratio"
            :src="image"
            @load="$emit('img-load')"
          />
          

          <!-- Zoom control -->
          <div class="image-loader-dialog__zoom">
            <v-icon class="image-loader-dialog__zoom-icon">mdi-magnify-minus-outline</v-icon>
            <clipper-range
              class="image-loader-dialog__zoom-control grow"
              :min="0.1"
              :max="3"
              v-model="scale"
            />
            <v-icon class="image-loader-dialog__zoom-icon">mdi-magnify-plus-outline</v-icon>
          </div>

          <!-- Actions -->
          <v-card-actions class="image-loader-dialog__actions">
            <div class="image-loader-dialog__info">
              <p v-if="!$vuetify.breakpoint.smAndDown" class="image-loader-dialog__info-text mb-2">
                <v-icon class="image-loader-dialog__info-icon">mdi-hand-right</v-icon>
                Arrastra la imagen.
              </p>
              <p>
                <v-icon class="image-loader-dialog__info-icon">mdi-magnify</v-icon>
                Desliza el control de zoom a la izquierda o la derecha para achicar o agrandar tu imagen.
              </p>
            </div>
            <v-spacer></v-spacer>
            <v-btn
              class="image-loader-dialog__btn"
              outlined
              :disabled="loading"
              :loading="loading"
              @click="upload"
            >
              ACTUALIZAR
            </v-btn>
            <v-btn
              class="image-loader-dialog__btn"
              outlined
              :disabled="loading"
              @click="dialog = false"
            >
              CANCELAR
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </div>
</template>

<script>
import { clipperFixed, clipperRange } from "vuejs-clipper";

export default {
    components: {
        clipperFixed,
        clipperRange
    },
    props: ["cols", "height", "width", "title", "ratio", "value", "default", "path"],
    data() {
        return {
            dialog: false,
            loading: false,
            hover: false,
            file: null,
            cacheBusting: "",
            image: "",
            scale: 1
        };
    },
    watch: {
        scale(val) {
            this.$refs.clipper.setWH$.next(+val);
        },
    },
    computed: {
        nratio() {
            let ratio = 1;
            if (this.ratio)
                ratio = parseInt(this.ratio);
            return ratio;
        },
        source() {
            /// TODO evitar obtencion 4040 cuando no se ha creado imagen ////
            let path = this.default;
            if (this.file && this.file != "")
                path = process.env.VUE_APP_ROOT_ASSETS + this.path + this.file + this.cacheBusting;
            return path;
        },
        dialogWidth() {
            if (this.$vuetify.breakpoint.xs) return "90%";
            else if (this.$vuetify.breakpoint.sm) return "70%";
            else if (this.$vuetify.breakpoint.md) return "50%";
            else if (this.$vuetify.breakpoint.lg) return "40%";
            else if (this.$vuetify.breakpoint.xl) return "30%";
            else return "20%";
        }
    },
    created() {
        this.file = this.value;
    },
    methods: {
        select() {
            this.isSelecting = true;
            window.addEventListener("focus", () => {
                this.isSelecting = false;
            }, { once: true });
            this.$refs.uploader.click();
        },
        load: function(e) {
            if (e.target.files.length !== 0) {
                if (this.image) URL.revokeObjectURL(this.image);
                this.image = window.URL.createObjectURL(e.target.files[0]);
                this.dialog = true;
            }
        },
        upload() {
            const canvas = this.$refs.clipper.clip();
            if (canvas) {
                const form = new FormData();
                canvas.toBlob(blob => {
                    this.loading = true;
                    this.$store.dispatch("uploads/getPermissions", {
                        scope: "organization",
                        type: "logo",
                        resource: {
                            path: this.path + this.file,
                            type: blob.type
                        }
                    }).then((data) => {
                        for (let field in data.presignedPostData.fields) {
                            form.append(field, data.presignedPostData.fields[field]);
                        }
                        form.append("file", blob);
                        this.$store.dispatch("uploads/upload", {
                            form: form,
                            url: data.presignedPostData.url
                        }).then(() => {
                            //this.file = data.path;
                            this.dialog = false;
                            this.loading = false;
                            this.$emit("input", this.file);
                            this.cacheBusting = "?" + new Date().getTime();
                        }).catch(err => {
                            console.error(err);
                            this.dialog = false;
                            this.loading = false;
                        });
                    }).catch(err => {
                        console.error(err);
                        this.dialog = false;
                        this.loading = false;
                    });
                }, "image/jpeg");
            }
        }
    }
};
</script>
